import { IPageBigHeader, IPageHeaderBlock, IPageSimpleHeader, IPageSmallHeader, TCmsBlocks } from '@features/cms/typescript';
import { IAccordion, IFrameAccordion } from '@features/pages/typescript';
export type TReturnsContent = {
  header: IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader> | null;
  frame: IFrameAccordion | null;
};
export const getReturnsHeaderTitle = (content?: TReturnsContent | null): string | null => {
  const header = content?.header;
  if (!header) {
    return null;
  }
  const {
    headerData,
    headerType
  } = header;
  if (headerType === 'simple') {
    return (headerData as IPageSimpleHeader).header || null;
  }
  if (headerType === 'small') {
    return (headerData as IPageSmallHeader).header || null;
  }
  if (headerType === 'big') {
    return (headerData as IPageBigHeader).subHeader || null;
  }
  return null;
};
export const getReturnsFrameDescription = (content?: TReturnsContent | null): string | null => {
  const frames = content?.frame?.frames;
  if (!frames?.length) {
    return null;
  }
  const description = frames.map(frame => frame.content).join('').trim();
  return description || null;
};
export const RETURNS_FAQ_CMS_SLUG = 'zwroty';
export const extractAccordionBlock = (content: Record<string, TCmsBlocks> | null): IAccordion | null => {
  if (!content) {
    return null;
  }
  const accordionByCode = Object.values(content).find(block => block.type === 'accordion' && block.code === RETURNS_FAQ_CMS_SLUG);
  if (accordionByCode) {
    return accordionByCode as IAccordion;
  }
  const accordionBlock = Object.values(content).find(block => block.type === 'accordion');
  return accordionBlock ? accordionBlock as IAccordion : null;
};
export const extractSmallHeaderBlock = (content: Record<string, TCmsBlocks> | null): TReturnsContent | null => {
  if (!content) {
    return null;
  }
  const headerBlock = Object.values(content).find(block => block.type === 'pageHeaderBlock') as IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader> | undefined;
  const frameBlock = Object.values(content).find(block => block.type === 'frame') as IFrameAccordion | undefined;
  return {
    header: headerBlock ?? null,
    frame: frameBlock ?? null
  };
};